import { render } from "./UploadAll.vue?vue&type=template&id=483c527c"
import script from "./UploadAll.vue?vue&type=script&lang=js"
export * from "./UploadAll.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__